module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(1), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento.contrato.unidade.nome))])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.CANCELADA),
      expression: "$props.solicitacao.situacao == SITUACAO_SOLICITACAO.CANCELADA"
    }]
  }, [_c('b', [_vm._v("Cancelada por: ")]), _vm._v(" " + _vm._s(_vm.nomeProfissionalCancelar(_vm.$props.solicitacao)))]), _vm._v(" "), _c('h1', {
    staticClass: "codigo-maior",
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm._f("formatarCodigo")(_vm.$props.solicitacao.id)))]), _vm._v(" "), _c('barcode', {
    attrs: {
      "marginBottom": "0",
      "align": "center",
      "displayValue": "false",
      "value": _vm.$props.solicitacao.id.toString().padStart(10, '0'),
      "format": "code39"
    }
  }, [_vm._v("\n            Erro no código de barras.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(3), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("tipoConsulta")(_vm.$props.solicitacao.itens[0].tipo_consulta)))])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_c('b', {
    staticClass: "maior"
  }, [_vm._v("Nome: " + _vm._s(_vm.$props.solicitacao.paciente.nome.toUpperCase()))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v("Nascimento: " + _vm._s(_vm._f("dataFormatada")(_vm.$props.solicitacao.paciente.data_nascimento)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v("Sexo: " + _vm._s(_vm._f("sexo")(_vm.$props.solicitacao.paciente.sexo)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v("Telefone: " + _vm._s(_vm.$props.solicitacao.paciente.telefone))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v("Município: " + _vm._s(_vm.$props.solicitacao.paciente.cidade.nome))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.EM_REGULACAO),
      expression: "$props.solicitacao.situacao == SITUACAO_SOLICITACAO.EM_REGULACAO"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_c('b', {
    attrs: {
      "align": "justify"
    }
  }, [_vm._v("\n                        AGUARDAR ANÁLISE DO MÉDICO REGULADOR E DISPONIBILIDADE DE VAGA."), _c('br'), _vm._v("\n                        ESTARÁ DISPONÍVEL NO PERÍODO DE " + _vm._s(_vm._f("dataFormatada")(_vm.$props.solicitacao.created_at)) + " ATÉ " + _vm._s(_vm._f("dataFormatada")(_vm.adicionarDiasData(_vm.$props.solicitacao.created_at, 2))) + ".\n                    ")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.solicitacao.diagnosticos.lenght > 0),
      expression: "$props.solicitacao.diagnosticos.lenght > 0"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(5), _vm._v(" "), _c('ul', _vm._l((_vm.$props.solicitacao.diagnosticos), function(item, index) {
    return _c('li', {
      key: index,
      staticStyle: {
        "margin-left": "-23px"
      }
    }, [_vm._v(_vm._s(item.nome))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(6), _vm._v(" "), _c('ul', _vm._l((_vm.$props.solicitacao.itens), function(item, index) {
    return _c('li', {
      key: index,
      staticStyle: {
        "margin-left": "-23px"
      }
    }, [_vm._v("\n                        " + _vm._s(item.quantidade) + " - " + _vm._s(item.contrato_procedimento.procedimento.codigo.replace(/[^\d]+/g, '')) + " - " + _vm._s(item.contrato_procedimento.procedimento.nome) + "\n                        "), (item.contrato_procedimento_atendimento) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.contrato_procedimento_atendimento.contrato_procedimento.preparo && _vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.MARCADA) || _vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.CONFIRMADA),
        expression: "(item.contrato_procedimento_atendimento.contrato_procedimento.preparo && $props.solicitacao.situacao == SITUACAO_SOLICITACAO.MARCADA) || $props.solicitacao.situacao == SITUACAO_SOLICITACAO.CONFIRMADA"
      }]
    }, [_c('b', [_vm._v("PREPARO (S):")])]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.contrato_procedimento_atendimento.contrato_procedimento.preparo && _vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.MARCADA) || _vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.CONFIRMADA),
        expression: "(item.contrato_procedimento_atendimento.contrato_procedimento.preparo && $props.solicitacao.situacao == SITUACAO_SOLICITACAO.MARCADA) || $props.solicitacao.situacao == SITUACAO_SOLICITACAO.CONFIRMADA"
      }],
      attrs: {
        "align": "justify"
      }
    }, [_c('strong', [_vm._v(_vm._s(item.contrato_procedimento_atendimento.contrato_procedimento.preparo ? item.contrato_procedimento_atendimento.contrato_procedimento.preparo.descricao : ""))])])])]) : _vm._e()])
  }))])]), _vm._v(" "), ((_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento || _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento) && (_vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.MARCADA || _vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.CONFIRMADA)) ? _c('span', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(7), _vm._v(" "), (_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento) ? _c('p', [_c('b', {
    staticClass: "maior"
  }, [_vm._v(_vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.nome))])]) : _vm._e(), _vm._v(" "), (_vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento) ? _c('p', [_c('b', {
    staticClass: "maior"
  }, [_vm._v(_vm._s(_vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.nome))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento) ? _c('b', [_c('p', {
    staticClass: "maior"
  }, [_vm._v(_vm._s(_vm._f("dataFormatada")(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.data_atendimento)) + ", " + _vm._s(_vm._f("diaDaSemana")(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.data_atendimento)) + ", às " + _vm._s(_vm._f("horaFormatada")(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.hora_inicial)) + "hrs")])]) : _vm._e(), _vm._v(" "), (_vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento) ? _c('b', [_c('p', {
    staticClass: "maior"
  }, [_vm._v(_vm._s(_vm._f("dataFormatada")(_vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.data_atendimento)) + ", " + _vm._s(_vm._f("diaDaSemana")(_vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.data_atendimento)) + ", às " + _vm._s(_vm._f("horaFormatada")(_vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.hora_inicial)) + "hrs")])]) : _vm._e()])]), _vm._v(" "), (_vm.$props.solicitacao.tipo_atendimento != null) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v("\n                            Endereço: " + _vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.endereco : _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.endereco) + ",\n                            " + _vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.numero_endereco : _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.numero_endereco) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_vm._v("Bairro: " + _vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.bairro : _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.bairro))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_vm._v("CEP: " + _vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.cep : _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.cep))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_vm._v("Município: " + _vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.cidade.nome : _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.cidade.nome))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_vm._v("Estado: " + _vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.cidade.uf.uf : _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.cidade.uf.uf))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_vm._v("Ponto de Referência: " + _vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.ponto_referencia : _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.ponto_referencia))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_vm._v("Telefone: " + _vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.telefone : _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.telefone))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v("Complemento: " + _vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.complemento_endereco : _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.complemento_endereco))])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.CANCELADA),
      expression: "$props.solicitacao.situacao == SITUACAO_SOLICITACAO.CANCELADA"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(8), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.justificativaCancelamento(_vm.$props.solicitacao)))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.solicitacao.tipo_atendimento !== 1 && (_vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.MARCADA || _vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.CONFIRMADA)),
      expression: "$props.solicitacao.tipo_atendimento !== 1 && ($props.solicitacao.situacao == SITUACAO_SOLICITACAO.MARCADA || $props.solicitacao.situacao == SITUACAO_SOLICITACAO.CONFIRMADA)"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(9), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.profissional.nome : ""))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(10), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$props.solicitacao.profissional.nome))])])]), _vm._v(" "), (_vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.REALIZADA) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(11), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("dataFormatada")(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.data_atendimento : _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.data_atendimento)))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(12), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$props.solicitacao.usuario.name))])])]), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_c('b', [_vm._v("Sec. Mun. de Saúde de Vitória da Conquista")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Unidade Solicitante:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_c('b', [_vm._v("AUTORIZAÇÃO DE PROCEDIMENTO")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Tipo de consulta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_c('b', [_vm._v("Paciente ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Diagnóstico(s)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Qt. - Procedimentos(s)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Realizar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Justificativa")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Profissional Realizador")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Profissional Solicitante")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Data da realização")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Marcador")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_c('b', [_vm._v("Informações")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    attrs: {
      "align": "justify"
    }
  }, [_vm._v("\n                    CASO VOCÊ NÃO PUDER COMPARECER À CONSULTA MÉDICA OU PROCEDIMENTO AGENDADO, FAVOR LIGAR 48 HORAS ANTES PARA DEVOLVER/CANCELAR A VAGA.\n                ")]), _vm._v(" "), _c('p', {
    attrs: {
      "align": "justify"
    }
  }, [_vm._v("\n                    PARA CANCELAMENTOS DE VAGAS, PROCURE SUA UNIDADE DE MARCAÇÃO.\n                ")]), _vm._v(" "), _c('p', {
    attrs: {
      "align": "justify"
    }
  }, [_vm._v("\n                    PARA REALIZAÇÃO DESSE PROCEDIMENTO, É NECESSÁRIO ESTAR COM OS DOCUMENTOS PESSOAIS, SOLICITAÇÃO DE PROCEDIMENTO E TAMBÉM O CARTÃO SUS.\n                ")]), _vm._v(" "), _c('p', {
    attrs: {
      "align": "justify"
    }
  }, [_vm._v("\n                    EXAMES PERDIDOS SÓ SERÃO REMARCADOS APÓS 30 DIAS.\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticStyle: {
      "font-size": "10px"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-9cb99efc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atendimentos/comuns/solicitacaoBoleto.vue
// module id = 886
// module chunks = 0